import * as React from "react";
import type { SVGProps } from "react";
const SvgCar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#car_svg__a)">
      <g fill="currentColor" clipPath="url(#car_svg__b)">
        <path d="M18.01 19.02c-1.65 0-3-1.35-3-3.02s1.35-3.02 3-3.02 3 1.35 3 3.02-1.35 3.02-3 3.02m0-4.04c-.55 0-1 .46-1 1.02s.45 1.02 1 1.02 1-.46 1-1.02-.45-1.02-1-1.02M6.01 19c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3m0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1" />
        <path d="M23.01 17h-3c-.55 0-1-.45-1-1s.45-1 1-1h2v-1c-.03-.38-1.07-2.66-5.31-4.05a.94.94 0 0 1-.4-.25c-.49-.49-.97-.9-1.88-1.4-1.15-.63-2.91-1.3-4.41-1.3h-4c-.34 0-1.18.42-1.41.71l-1.32 1.4c-.18.19-.27.43-.27.69v2.21c0 .27-.11.52-.29.71l-.71.71c.02.42.12 1.05.43 1.38.09.1.24.21.57.21.55 0 1 .45 1 1s-.45 1-1 1c-.81 0-1.51-.29-2.03-.85C-.1 15.01 0 13.14 0 12.93c.02-.24.12-.47.29-.64l.71-.71V9.79c0-.77.29-1.5.82-2.06l1.27-1.34C3.67 5.67 5.05 5 6.01 5h4c1.6 0 3.61.58 5.38 1.55 1.01.55 1.61 1.04 2.16 1.57 4.7 1.61 6.46 4.44 6.46 5.87v2c0 .55-.45 1-1 1z" />
        <path d="M15.01 17h-7c-.55 0-1-.45-1-1s.45-1 1-1h7c.55 0 1 .45 1 1s-.45 1-1 1M13.01 12c-.05 0-.11 0-.17-.01l-6-1a.999.999 0 0 1 .33-1.97l6 1c.54.09.91.61.82 1.15a1 1 0 0 1-.99.84z" />
      </g>
    </g>
    <defs>
      <clipPath id="car_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
      <clipPath id="car_svg__b">
        <path fill="#fff" d="M0 5h24.01v14.02H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCar;
